const puntoControlInitialState = {
  puntoControl: {
    idTipo: null,
    data: null,
    error: false,
    loading: null,
    dto: null,
  },
};

export default puntoControlInitialState;
